export default __webpack_public_path__ + "static/media/spinner.e3e722d7.gif";